var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.613 8.97289L9.91966 8.77956C9.513 8.73289 9.113 8.87289 8.82633 9.15956L7.59966 10.3862C5.713 9.42623 4.16633 7.88623 3.20633 5.99289L4.43966 4.75956C4.72633 4.47289 4.86633 4.07289 4.81966 3.66623L4.62633 1.98623C4.54633 1.31289 3.97966 0.806227 3.29966 0.806227H2.14633C1.393 0.806227 0.766329 1.43289 0.812996 2.18623C1.16633 7.87956 5.71966 12.4262 11.4063 12.7796C12.1597 12.8262 12.7863 12.1996 12.7863 11.4462V10.2929C12.793 9.61956 12.2863 9.05289 11.613 8.97289Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.3961b0888b027c94ab4695d0e56bb8d3.svg";
export { ForwardRef as ReactComponent };